import React from 'react';
import { MONITORING_PRIORITIES, MonitoringPriority } from 'services/monitoring_settings';
import { Badge } from './styles';

const MonitoringPriorityBadge = ({ priority }: { priority: MonitoringPriority }) => (
  <Badge className={`priority-${priority}`}>
    {MONITORING_PRIORITIES.find(({ value }) => value === priority)?.label}
  </Badge>
);

export default MonitoringPriorityBadge;
